import { useState } from "react";
import { Flag } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";

export const ReportCommentButton = ({ commentId }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/community/comments/${commentId}/report`, { reason });
      toast.success(r.data.already ? "You already reported this comment" : "Thanks — our team will review this comment");
      setOpen(false); setReason("");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid={`report-comment-${commentId}`} className="ml-auto inline-flex items-center gap-1 text-xs text-[#4A5568] hover:text-red-600 transition-colors"><Flag size={13} /> Report</button>
      </DialogTrigger>
      <DialogContent data-testid="report-dialog">
        <DialogHeader><DialogTitle>Report this comment</DialogTitle></DialogHeader>
        <p className="text-sm text-[#4A5568]">Tell us what's wrong (optional). Only the Real&State team sees your report.</p>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} maxLength={300} placeholder="e.g. Offensive language, spam, harassment" data-testid="report-reason-input" />
        <Button onClick={submit} disabled={busy} data-testid="report-submit-btn" className="rounded-full bg-red-600 hover:bg-red-700 text-white">Send report</Button>
      </DialogContent>
    </Dialog>
  );
};
